import { Injectable } from '@angular/core';
import { Content } from '../models/content.model';
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

import webpageQuery from 'src/app/graphql/queries/webpage.query.graphql'
import webpagesQuery from 'src/app/graphql/queries/webpages.query.graphql'

@Injectable()
export class ContentService extends GraphQLService<Content> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  pages(iso: string, area: number) {
    // areas: 1: Main nav, 2: Footer nav, 3: right nav
    return this.findAll(webpagesQuery, {iso, area})
  }

  page(id: number, iso: string) {
    return this.find(webpageQuery, {id, iso})
  }

}
